/**
 * lastContactLabel — Pure Function (BOARD-08).
 *
 * Liefert "Heute" / "Gestern" / "vor X Tagen" basierend auf dem juengsten
 * Kontaktzeitpunkt:
 *   1. lastContactAt  (manuell gesetzt, z.B. nach Telefonat)
 *   2. lastReplyAt    (eingehender Reply)
 *   3. receivedAt     (Lead-Erstellung, Fallback)
 *
 * Falls keiner gesetzt: 'Noch kein Kontakt'.
 * Pure: now ist Argument, testbar mit fixen Zeitstempeln.
 */

import { differenceInDays } from 'date-fns';
import type { Lead } from '../types';

export function lastContactLabel(lead: Lead, now: Date = new Date()): string {
  const ts = lead.lastContactAt ?? lead.lastReplyAt ?? lead.receivedAt;
  if (!ts) return 'Noch kein Kontakt';

  const days = differenceInDays(now, new Date(ts));

  if (days <= 0) return 'Heute';
  if (days === 1) return 'Gestern';
  return `vor ${days} Tagen`;
}
